
module.exports = function getResource(label, vars = []) {
    const resources = { all: 'Tous ' };
    return resources[label];
};
